import Splide from "@splidejs/splide";

const splideInstances = new Map();

export const programDetailSlider = (root = document) => {
  const sliders = root.querySelectorAll(".js-program-detail-slider");
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    // 再初期化時は既存インスタンスを再利用
    if (splideInstances.has(slider)) return;

    const splide = new Splide(slider, {
      type: "loop",
      perPage: 1,
      perMove: 1,
      gap: "1rem",
      arrows: false,
      classes: {
        pagination: "program-detail-slider__pagination",
        page: "program-detail-slider__pagination-page",
      },
      breakpoints: {
        768: {
          gap: "0.8rem",
        },
      },
    });

    splide.mount();

    // インスタンスを保存
    splideInstances.set(slider, splide);
  });
};

// スライダーをリフレッシュする関数をエクスポート
export const refreshSlider = (slider) => {
  const splide = splideInstances.get(slider);
  if (splide) {
    // リフレッシュ前にopacityを0にリセット
    slider.classList.remove("is-ready");

    splide.refresh();

    // リフレッシュ完了後にopacityを1にする
    setTimeout(() => {
      slider.classList.add("is-ready");
    }, 100);
  }
};

export default programDetailSlider;
